import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useT } from "@/i18n";
import PhonePreview from "@/components/appbuilder/PhonePreview";
import { Stars } from "@/components/SkyDecor";

export default function SharedApp() {
  const { shareId } = useParams();
  const { lang } = useT();
  const [project, setProject] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    axios.get(`${API}/apps/public/${shareId}`).then((r) => setProject(r.data)).catch(() => setMissing(true));
  }, [shareId]);

  return (
    <div className="min-h-screen sky-bg relative overflow-hidden py-10 px-4" data-testid="shared-app-page">
      <Stars />
      <div className="relative text-center">
        <h1 className="font-fredoka text-3xl sm:text-5xl font-bold bubble-text text-white">
          {missing ? (lang === "es" ? "App no encontrada" : "App not found") : project?.name}
        </h1>
        <p className="mt-2 inline-block bg-white/90 rounded-full px-4 py-1.5 font-bold text-blue-900 text-sm">
          {lang === "es" ? "Creada en Lumi & Spark Kids Lab" : "Made in Lumi & Spark Kids Lab"}
        </p>
      </div>
      {project && (
        <div className="relative mt-8 flex items-end justify-center gap-4">
          <img src="/img/lumi.webp" alt="" className="hidden sm:block w-32 mascot-wiggle" />
          <PhonePreview project={project} />
          <img src="/img/spark.webp" alt="" className="hidden sm:block w-32 mascot-wiggle" />
        </div>
      )}
      <div className="relative text-center mt-8">
        <Link to="/" className="glossy-btn inline-block bg-yellow-300 text-blue-900 font-fredoka font-bold text-xl px-8 py-3 rounded-full" data-testid="shared-app-cta">
          {lang === "es" ? "¡Crea la tuya!" : "Create yours!"}
        </Link>
      </div>
    </div>
  );
}
